/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  formatHealthcardNumber,
  formatHealthcardVersion,
  formatPhoneNumber,
} from "./formatting";

function cloneInputObject(object: unknown) {
  // Clone the input object. Sould be sufficient since we're dealing with form data.
  return JSON.parse(JSON.stringify(object));
}

export function sanitizeUpdateClientFormData(data: any) {
  // ToDo: Move this server-side
  const sanitized = cloneInputObject(data);

  function formatField(
    sectionNum: number,
    fieldLabel: string,
    format: (value: any) => any
  ) {
    if (sanitized?.[`section${sectionNum}`]?.[fieldLabel]) {
      sanitized[`section${sectionNum}`][fieldLabel] = format(
        sanitized[`section${sectionNum}`][fieldLabel]
      );
    }
  }

  formatField(1, "health-card", formatHealthcardNumber);
  formatField(1, "version-code", formatHealthcardVersion);
  formatField(3, "business-tel", formatPhoneNumber);
  formatField(3, "primary-tel", formatPhoneNumber);
  formatField(4, "authorizer-business-telephone-number", formatPhoneNumber);

  return sanitized;
}

export function sanitizeUpdateClientData(data: any) {
  // ToDo: Move this server-side
  const sanitized = cloneInputObject(data);

  if (sanitized?.cep) sanitized.cep = sanitized.cep === "true";

  if (sanitized?.address?.phone)
    sanitized.address.phone = formatPhoneNumber(sanitized.address.phone);

  if (sanitized?.agent?.phone)
    sanitized.agent.phone = formatPhoneNumber(sanitized.agent.phone);

  if (sanitized?.agent?.business_phone)
    sanitized.agent.business_phone = formatPhoneNumber(
      sanitized.agent.business_phone
    );

  if (sanitized?.health_card)
    sanitized.health_card = formatHealthcardNumber(sanitized.health_card);

  if (sanitized?.health_card_version)
    sanitized.health_card_version = formatHealthcardVersion(
      sanitized.health_card_version
    );

  // Empty enum text fields should be null (Strapi v4 rejects empty strings for enums)
  const addressProvince = sanitized?.address?.province;
  if (!addressProvince && addressProvince !== undefined) {
    sanitized.address.province = null;
  }

  const agentProvince = sanitized?.agent?.province;
  if (!agentProvince && agentProvince !== undefined) {
    sanitized.agent.province = null;
  }

  // Ensure relation fields are arrays, not empty strings from form defaults
  // (Strapi v4 entityService hangs if many-to-many relations receive "")
  if (sanitized.sales_reps !== undefined && !Array.isArray(sanitized.sales_reps)) {
    sanitized.sales_reps = sanitized.sales_reps ? [sanitized.sales_reps] : [];
  }
  if (sanitized.authorizers !== undefined && !Array.isArray(sanitized.authorizers)) {
    sanitized.authorizers = sanitized.authorizers ? [sanitized.authorizers] : [];
  }

  // Clear social benefits selection did not answer Yes
  if (
    sanitized.social_benefits !== undefined &&
    sanitized.social_benefits !== "true"
  ) {
    sanitized.social_assistance = null;
  }
  delete sanitized.social_benefits;

  return sanitized;
}

export function sanitizeCreateUserData(data: any) {
  const sanitized = cloneInputObject(data);
  if (sanitized.location) {
    sanitized.locations = [sanitized.location.value];
    delete sanitized.location;
  }
  // ToDo: Prevent clash: https://app.asana.com/0/1200279486914563/1201349165016440/f
  sanitized.username =
    `${sanitized.first_name}${sanitized.last_name}`.toLowerCase();
  // Create a random password
  sanitized.password =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  sanitized.cep = sanitized.cep === "true";
  sanitized.password_updated_at = new Date();
  sanitized.mfa_enabled = false;
  return sanitized;
}
